import type { Nullable } from "models-webgl2";
import { SHADER_DATA_TYPE_COUNT, SHADER_DATA_TYPE_TO_WEBGL_BASE_TYPE } from "../webgl2.constants";
import { VertexBuffer, IndexBuffer } from "./buffer";

export class VertexArray {
  public gl: WebGL2RenderingContext;
  public vao: WebGLVertexArrayObject;
  public vertexBuffers: VertexBuffer[];
  public indexBuffer: Nullable<IndexBuffer>;

  constructor(
    gl: WebGL2RenderingContext,
    vertexBuffers: VertexBuffer[],
    indexBuffer?: IndexBuffer,
  ) {
    this.gl = gl;
    this.vertexBuffers = vertexBuffers;
    this.indexBuffer = indexBuffer;

    this.vao = gl.createVertexArray() as WebGLVertexArrayObject;
    this.bind();

    let _vertexBufferIndex = 0;

    vertexBuffers.forEach((vertexBuffer) => {
      vertexBuffer.bind();

      vertexBuffer.layout.elements.forEach((elem) => {
        gl.enableVertexAttribArray(_vertexBufferIndex);
        gl.vertexAttribPointer(
          _vertexBufferIndex,
          SHADER_DATA_TYPE_COUNT[elem.type],
          SHADER_DATA_TYPE_TO_WEBGL_BASE_TYPE[elem.type],
          elem.normalized,
          vertexBuffer.layout.stride,
          elem.offset,
        );

        _vertexBufferIndex++;
      });
    });

    indexBuffer?.bind();

    this.unbind();
  }

  bind() {
    this.gl.bindVertexArray(this.vao);
  }

  unbind() {
    this.gl.bindVertexArray(null);
  }
}
